import { createSelector } from 'reselect'
import { get } from 'lodash'

const createMapAwardUnits = () =>
  createSelector(
    awardUnits => awardUnits,
    (_, conditions) => conditions,
    (awardUnits, { isIac, isPresentOa, isPresentIc }) => {
      return awardUnits
        .filter(item => {
          if (isIac) {
            return get(item, 'hierarchyLevel.value') === 'IAC'
          } else if (isPresentOa && isPresentIc) {
            return item
          } else {
            return true
          }
        })
        .map(item => ({
          label: item.name,
          value: item.id,
          subLabel: `${get(item, 'invoiceAddress.line1')} ${get(item, 'invoiceAddress.line2')}`
        }))
    }
  )

export default createMapAwardUnits
